import LeftSection from "./left";
import RightSection from "./right";

export default function MainSection({ pageHeading, content }) {
  return (
    <div className="div-main">
      <div id="cover-spin"></div>
      <div
        className="Table"
        style={{
          width: "1024px",
          height: "100%",
          margin: "0px auto",
          top: "0px",
          background: "transperant",
        }}
      >
        <div className="Row">
          <LeftSection />
          <RightSection pageHeading={pageHeading} content={content} />
        </div>
      </div>
    </div>
  );
}
